import {
  GET_OFFICES,
  CREATE_OFFICES,
  DELETE_OFFICES,
  UPDATE_OFFICES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  GET_OFFICES_BY_ID,
} from './actionType';

// common success
export const OfficesApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const OfficesApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const Offices = () => ({
  type: GET_OFFICES,
});

export const CreateOffices = (data) => ({
  type: CREATE_OFFICES,
  payload: { data },
});

export const UpdateOffices = (id, data) => ({
  type: UPDATE_OFFICES,
  payload: { id, data },
});

export const DeleteOffices = (id) => ({
  type: DELETE_OFFICES,
  payload: { id },
});

export const GetOfficesById = (id) => ({
  type: GET_OFFICES_BY_ID,
  payload: { id },
});
